// dashboard/frontend/src/components/Campaign/channels/instagram/InstagramDraftRow.js

import React from 'react';
import BaseDraftRow from '../BaseDraftRow';
import InstagramDraftActions from './InstagramDraftActions';
import ChannelFactory from '../ChannelFactory';

/**
 * Instagram-specific draft row wrapper
 * This component combines BaseDraftRow (shared display logic) 
 * with InstagramDraftActions (Instagram-specific buttons)
 */
const InstagramDraftRow = ({ 
    contact, 
    draft,
    onOpenDialog,
    onRefreshDraft,
    onDeleteDraft,
}) => {
    // Get Instagram channel configuration from factory
    const channelConfig = ChannelFactory.getChannelConfig('instagram_dm');

    // Render function for Instagram-specific action buttons
    const renderActions = (props) => (
        <InstagramDraftActions
            {...props}
            onOpenDialog={onOpenDialog}
            onRefreshDraft={onRefreshDraft}
            onDeleteDraft={onDeleteDraft}
        />
    );

    // Use BaseDraftRow with Instagram config and actions
    return (
        <BaseDraftRow
            contact={contact}
            draft={draft}
            channelConfig={channelConfig}
            actions={renderActions}
        />
    );
};

export default InstagramDraftRow;